export * from './confirm-dialog.component';
export * from './confirm-dialog.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/confirm-dialog/index.ts